export default {
    api: {
        baseurl: "https://api.vue.eatery-portal.com/",
        version: "api/v0.1"
    },

    application: "eateryportal",    // iOS/Androidアプリ名

    expired_sec: 60 * 60 * 12,   // 仮タイムアウト（12時間）
}